"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.printDonationReminder = void 0;
var getConsoleLogArguments_1 = require("./utils/styled-log/getConsoleLogArguments");
var shuffle_1 = require("./utils/shuffle");
var getDonationReminderLog_1 = require("./getDonationReminderLog");
var isDisabled_1 = require("./isDisabled");
var collectCalls_1 = require("./collectCalls");
var extractLsosProjectInfo_1 = require("./extractLsosProjectInfo");
var validateLsosProject_1 = require("./validateLsosProject");
main();
// Entry point: libraries who wish to show the donation-reminder
// to their users call the `printDonationReminder` function.
// We internally call them "Lsos projects".
function printDonationReminder(args) {
    var lsosProject = processArgs(args);
    collectCalls_1.collectLsosProject(lsosProject);
}
exports.printDonationReminder = printDonationReminder;
function main() {
    return __awaiter(this, void 0, void 0, function () {
        var lsosProjects;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, collectCalls_1.getCollectedLsosProjects()];
                case 1:
                    lsosProjects = _a.sent();
                    // Abort, if the donation-reminder is disabled,
                    // for example when the user has run `yarn lsos remove` or
                    // when run in production.
                    if (isDisabled_1.isDisabled(lsosProjects)) {
                        return [2 /*return*/];
                    }
                    // `console.log` the donation-reminder
                    print(lsosProjects);
                    return [2 /*return*/];
            }
        });
    });
}
function print(lsosProjects) {
    // Shuffle the list of projects to avoid the unfair situation
    // where the same projects are shown first.
    lsosProjects = shuffle_1.shuffle(lsosProjects);
    // Compute the donation-reminder
    var donationReminderLog = getDonationReminderLog_1.getDonationReminderLog(lsosProjects);
    // `console.log` the donation-reminder
    console.log.apply(console, getConsoleLogArguments_1.getConsoleLogArguments(donationReminderLog));
}
// Process function overloading and validate user input
function processArgs(args) {
    var lsosProject;
    // Process function overloading
    if (args.name) {
        var packageJson = args;
        lsosProject = extractLsosProjectInfo_1.extractLsosProjectInfo(packageJson);
    }
    else {
        lsosProject = args;
    }
    // Throw an exception upon wrong usage of `printDonationReminder()`
    validateLsosProject_1.validateLsosProject(lsosProject);
    return lsosProject;
}
//# sourceMappingURL=printDonationReminder.js.map